/** @module Enums */ /** typedoc */

export enum FeatureEnum {
    LowResMp3 = 'LowResMp3',
    SoundCloudOgg = 'SoundCloudOgg',
    HiResMp3 = 'HiResMp3',
    Wav = 'Wav',
    SoundCloudWav = 'SoundCloudWav',
    HdWav = 'HdWav',
    StemMp4 = 'StemMp4',
    Video = 'Video',
    Distribution = 'Distribution'
}
